<template lang="pug">
#ministries
  .page-controls
    b-field(grouped)
      b-field(expanded)
        search-field(
          :value="filters.query"
          @change="setFilterField($event, 'query')"
          @reset="resetQuery"
        )
      b-field(v-if="activeTabLabel === 'members'")
        b-select(
          :value="filters.approved"
          @input="setFilterField($event, 'approved')"
        )
          option(value="all") All
          option(:value="true") Approved
          option(:value="false") Not Approved
      b-field(v-if="activeTabLabel === 'members'")
        .control
          b-dropdown
            a.button.is-success(slot="trigger")
              span New Church Member
              b-icon(icon="chevron-down")
            b-dropdown-item(@click="triggerNew")
              b-icon(icon="account")
              span Single Member
            b-dropdown-item(@click="triggerImport")
              b-icon(icon="account-multiple")
              span Multiple Members
      b-field(v-else)
        .control
          button.button.is-success(@click="triggerNew")
            b-icon(icon="plus")
            span {{ newButtonLabel }}
  spinner(v-if="settings.loading")
  b-tabs.page-tabs(
    v-else
    position="is-centered"
    v-model="activeTab"
    :animated="false"
    @change="changeTab"
  )
    b-tab-item(label="Ministries")
      ministries-tab
    b-tab-item(label="Service Times")
      services-tab
    b-tab-item(label="Staff Members")
      staff-members-tab
    b-tab-item(
      label="Church Members"
      :disabled="!account.premium_episodes"
    )
      members-tab
    b-tab-item(label="Belief Statements")
      belief-statements-tab
</template>

<script>
import { mapGetters } from 'vuex';
import BeliefStatementForm from '@/components/form/BeliefStatementForm';
import BeliefStatementsTab from '@/components/BeliefStatementsTab';
import MemberForm from '@/components/form/MemberForm';
import MemberImportModal from '@/components/MemberImportModal';
import MembersTab from '@/components/MembersTab';
import MinistryForm from '@/components/form/MinistryForm';
import MinistriesTab from '@/components/MinistriesTab';
import SearchField from '@/components/form/SearchField';
import ServiceForm from '@/components/form/ServiceForm';
import StaffMemberForm from '@/components/form/StaffMemberForm';
import ServicesTab from '@/components/ServicesTab';
import StaffMembersTab from '@/components/StaffMembersTab';
import Spinner from '@/components/Spinner';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'ministries',
  components: {
    BeliefStatementsTab,
    MembersTab,
    MinistriesTab,
    SearchField,
    ServicesTab,
    StaffMembersTab,
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      filters: getters.GET_MINISTRY_FILTERS,
      ministries: getters.GET_MINISTRIES,
    }),
    activeTabLabel() {
      return this.tabs[this.activeTab];
    },
    newButtonLabel() {
      let label;
      switch (this.activeTabLabel) {
        case 'ministries':
          label = 'Ministry';
          break;
        case 'services':
          label = 'Service Time';
          break;
        case 'staff':
          label = 'Staff Member';
          break;
        case 'members':
          label = 'Church Member';
          break;
        case 'belief_statements':
          label = 'Belief Statement';
          break;
        default:
      }
      return `New ${label}`;
    },
  },
  created() {
    if (this.tab) this.activeTab = this.tab;
  },
  data() {
    return {
      activeTab: 0,
      query: null,
      settings: {
        loading: false,
      },
      tabs: [
        'ministries',
        'services',
        'staff',
        'members',
        'belief_statements',
      ],
    };
  },
  methods: {
    changeTab(index) {
      // this.$store.commit(mutations.SET_MEDIA_TAB, tab);
      this.$router.push({ name: 'ministries', query: { tab: index } });
      if (this.filters.query) {
        this.resetQuery();
      }
    },
    resetQuery() {
      this.query = null;
      this.$store.commit(mutations.SET_MINISTRY_FILTER_FIELD, {
        key: 'query',
        val: null,
      });
      this.$store.commit(mutations.SET_MINISTRY_REFRESH, true);
    },
    setFilterField(val, key) {
      this.$store.commit(mutations.SET_MINISTRY_FILTER_FIELD, {
        key,
        val,
      });
      this.$store.commit(mutations.SET_MINISTRY_REFRESH, true);
    },
    triggerNew() {
      const opts = {
        parent: this,
        hasModalCard: true,
      };
      switch (this.activeTabLabel) {
        case 'ministries':
          this.$store.commit(mutations.UNSET_MINISTRY);
          opts.component = MinistryForm;
          break;
        case 'services':
          this.$store.commit(mutations.UNSET_SERVICE);
          opts.component = ServiceForm;
          break;
        case 'staff':
          this.$store.commit(mutations.UNSET_STAFF_MEMBER);
          opts.component = StaffMemberForm;
          break;
        case 'members':
          this.$store.commit(mutations.UNSET_MEMBER);
          opts.component = MemberForm;
          break;
        case 'belief_statements':
          this.$store.commit(mutations.UNSET_BELIEF_STATEMENT);
          opts.component = BeliefStatementForm;
          break;
        default:
      }
      this.$buefy.modal.open(opts);
    },
    triggerImport() {
      this.$buefy.modal.open({
        parent: this,
        component: MemberImportModal,
        hasModalCard: true,
      });
    },
  },
  props: ['tab'],
};
</script>

<style lang="scss">
#ministries {
  table {
    tr {
      cursor: pointer;
      .drag-icon {
        cursor: move;
      }
      a {
        text-decoration: underline;
      }
      &:hover {
        .drag-icon {
          color: $theme-primary !important;
        }
      }
    }
  }
  .dropdown-menu {
    .dropdown-content {
      .dropdown-item {
        display: flex;
        align-items: center;
        &:focus {
          outline: none;
        }
        .icon {
          margin-right: 0.15rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Ministries.vue